import { getFeedbackUsers } from '@api/user/apiService.ts';
import InputFieldWithDebounce from '@components/InputFieldWithDebounce/ui/InputFieldWithDebounce';
import Table from '@components/Table/ui/Table.tsx';
import NoUsersFound from '@features/NoUsersFound/NoUsersFound.tsx';
import getFeedbackUserHeaderList from '@shared/tables/FeedbackUser/FeedbackUser';
import { useEffect, useMemo, useState } from 'react';
import { FeedbackUser } from '../model/types';
import styles from './AdminPanelFeedbackUsers.module.scss';

function AdminPanelFeedbackUsers() {
  const [itemsPerPage, _] = useState(9);
  const [feedbackList, setFeedbackList] = useState<FeedbackUser[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');

  const fetchFeedbackList = () => {
    getFeedbackUsers((data: FeedbackUser[]) => {
      setFeedbackList(data);
    });
  };

  useEffect(() => {
    fetchFeedbackList();
  }, []);

  const dataList = useMemo(() => {
    return feedbackList.filter((item) =>
      searchValue
        ? item.creator?.name.includes(searchValue) ||
          item.creator?.email.includes(searchValue)
        : true
    );
  }, [feedbackList, searchValue]);

  return (
    <div className={styles.AdminPanelFeedbackUsersWrapper}>
      <div className={styles.header}>
        <div className={styles.feedbackSearch}>
          <InputFieldWithDebounce
            debounceAction={setSearchValue}
            image={<img src="/icons/search.svg" alt="" />}
            placeholder="Search user..."
            name="searchInput"
          />
        </div>
      </div>

      <Table
        noDataRenderer={() => <NoUsersFound />}
        onRowClick={() => {}}
        itemsPerPage={itemsPerPage}
        columns={getFeedbackUserHeaderList()}
        style={{ marginTop: '24px' }}
        data={dataList}
        pagination
        rowHeight="auto"
        initSortColumnKey="created_at"
      />
    </div>
  );
}

export { AdminPanelFeedbackUsers };
